import { isPlainObject } from "lodash";

// Maps an object and its nested objects and arrays with a function to new values
export function mapValuesDeep(obj: any, fn: (value: any, key: string, obj: any) => any): any {
  if (Array.isArray(obj)) {
    return obj.map((item) => mapValuesDeep(item, fn));
  }
  if (isPlainObject(obj)) {
    return Object.keys(obj).reduce<Record<string, any>>((acc, key) => {
      acc[key] = mapValuesDeep(obj[key], fn);
      return acc;
    }, {});
  }
  return fn(obj, "", obj);
}
